var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 104,
    viewBox: "0 0 400 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35492",
    "data-name": "Rectangle 35492",
    width: 400,
    height: 104,
    transform: "translate(746 585)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_196",
    "data-name": "Mask Group 196",
    transform: "translate(-746 -585)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41196",
    "data-name": "Group 41196",
    transform: "translate(533 442.325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35486",
    "data-name": "Rectangle 35486",
    width: 7.438,
    height: 41.627,
    transform: "translate(387.207 179.467) rotate(-102.666)",
    fill: "#bcc0cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35487",
    "data-name": "Rectangle 35487",
    width: 7.438,
    height: 41.628,
    transform: "translate(433.359 194.98) rotate(77.335)",
    fill: "#bcc0cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35488",
    "data-name": "Rectangle 35488",
    width: 11.221,
    height: 70.501,
    transform: "matrix(0.976, -0.219, 0.219, 0.976, 388.602, 155.966)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41194",
    "data-name": "Group 41194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34509",
    "data-name": "Path 34509",
    d: "M801.442,208.3v2.782a178.219,178.219,0,0,0-24.047,7.689,115.873,115.873,0,0,1-23.715,6.3l-.2.03c-.156.019-.3.048-.451.068a164.9,164.9,0,0,1-21.118,1.949c-.137.01-.264.01-.4.01-.187.01-.383.01-.569.02-.225,0-.441.01-.656.01-.3,0-.6.01-.882.01-.509.01-.97.01-1.381.01-1.557,0-2.449-.04-2.5-.04a20.922,20.922,0,0,1-8.591-2.067,31.825,31.825,0,0,1-6.954-4.613,61.106,61.106,0,0,1-4.721-4.525c-.079-.078-.147-.148-.216-.226-.108-.107-.215-.225-.313-.333-.137-.146-.264-.284-.391-.43-1.029-1.118-2.068-2.283-3.106-3.5q-.221-.264-.44-.529c-1.715-2.008-3.448-4.134-5.261-6.348-11.832-14.466-26.556-32.47-53.58-44.548a100.587,100.587,0,0,0-27.152-7.611c-.128-.019-.265-.039-.393-.05-1.126-.166-2.262-.3-3.418-.42-.421-.049-.862-.1-1.293-.137-.461-.049-.921-.089-1.382-.128-.391-.039-.793-.068-1.194-.1-18.582-1.449-39.681.931-63.17,7.131-.44.118-.882.226-1.322.343v.01c-.245.059-.489.128-.744.2-.579.156-1.166.323-1.754.479-1.087.3-2.165.618-3.262.941-.127.029-.255.069-.382.108q-8.463,2.469-17.338,5.573c-1.548.54-2.762.97-3.565,1.215a116.15,116.15,0,0,1-18.651,4.329c-1.028.148-2.007.265-2.918.363-1.058.108-2.038.2-2.939.255a40.475,40.475,0,0,1-7.014-.02l.333-2.693a41.2,41.2,0,0,0,6.074.01c.881-.059,1.871-.138,2.948-.236.9-.1,1.881-.216,2.919-.352a112.4,112.4,0,0,0,18.435-4.242c.764-.235,1.959-.656,3.477-1.2,3.8-1.332,9.942-3.477,17.681-5.75,1.949-.568,4.007-1.145,6.151-1.724.185-.058.362-.108.549-.147a243.86,243.86,0,0,1,26.682-5.6,167.978,167.978,0,0,1,38.623-1.616,2.729,2.729,0,0,1,.4.03q3.247.264,6.376.705a103.159,103.159,0,0,1,28.347,7.856c27.623,12.342,42.561,30.62,54.57,45.3,2.009,2.459,3.909,4.78,5.74,6.926.206.234.412.469.608.705.451.518.891,1.018,1.332,1.508.1.118.206.235.3.353.481.528.951,1.038,1.421,1.537.244.274.5.539.773.8a48.2,48.2,0,0,0,4.7,4.379,25.616,25.616,0,0,0,6.9,4.132,18.3,18.3,0,0,0,6.211,1.235c.068,0,1.488.049,3.928.019,1.137-.009,2.5-.039,4.046-.1.538-.029,1.116-.049,1.7-.078a163.606,163.606,0,0,0,16.681-1.676c.176-.029.362-.059.539-.078.048-.01.1-.02.136-.03a114.34,114.34,0,0,0,23.745-6.229A181.055,181.055,0,0,1,801.442,208.3Z",
    fill: "#bcc0cf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34510",
    "data-name": "Path 34510",
    d: "M464.319,143.23,442.676,148.1l14.337,63.794,21.642-4.865a22.611,22.611,0,0,0,17.1-27.019l-4.42-19.671A22.613,22.613,0,0,0,464.319,143.23Z",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35489",
    "data-name": "Rectangle 35489",
    width: 5.849,
    height: 16.852,
    transform: "matrix(-0.976, 0.219, -0.219, -0.976, 498.25, 177.75)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41195",
    "data-name": "Group 41195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34511",
    "data-name": "Path 34511",
    d: "M377.25,191.721l-.45,2.97c-.19-.03-20.27-2.4-51.88,31.9-7.04,7.64-17.07,11.11-29.83,10.31-24.81-1.55-51.679-18.79-60.01-30.47-5.7-7.97-12.43-12.15-20.03-12.42-14.24-.5-32.3,12.32-53.71,38.15-7.14,8.61-13.369,12.63-19.03,12.24-7.62-.509-12.8-8.78-17.81-16.78-4.97-7.95-10.11-16.16-17.31-16.71-5.88-.43-12.85,4.12-21.279,13.94-13.391,15.6-28.571,24.02-45.12,25.03-1.151.07-2.291.11-3.42.11-15.851,0-29.271-6.65-37.371-11.88v-3.66c8.06,5.441,23.17,13.52,40.64,12.441,15.69-.971,30.16-9.041,42.99-23.991,9.1-10.6,16.88-15.5,23.79-14.98,8.71.66,14.261,9.53,19.63,18.11,4.81,7.7,9.361,14.97,15.46,15.37,4.63.31,10.04-3.34,16.52-11.15,22.35-26.96,40.691-39.81,56.131-39.24,8.569.31,16.1,4.91,22.359,13.68,7.8,10.93,34.18,27.75,57.76,29.22,11.8.731,21.04-2.41,27.441-9.36C355.58,188.9,376.38,191.591,377.25,191.721Z",
    fill: "#bcc0cf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34512",
    "data-name": "Path 34512",
    d: "M385.742,226.246l21.643-4.864-14.336-63.794L371.4,162.452a22.612,22.612,0,0,0-17.1,27.02l4.421,19.671A22.612,22.612,0,0,0,385.742,226.246Z",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35490",
    "data-name": "Rectangle 35490",
    width: 5.849,
    height: 16.852,
    transform: "translate(351.812 191.727) rotate(-12.664)",
    fill: "#dbdff0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/errorImage.c9c11c0346f5c544e1031e4dd063af49.svg";
export { ForwardRef as ReactComponent };